//
// Copyright (c) 2024 Comcast
//

import PropTypes from 'prop-types'
import { Field } from 'react-final-form'
import styled, { css } from 'styled-components'
import Select from 'components/Shared/Select/Index'
import { customIsEqual } from './utils'

const StyledSelect = styled(Select)`
  ${props => !props.multiselect && css`
    margin-right: 80px;
  `}
`

const PORTAL_Z_INDEX = 10001

const SelectField = ({
  name, placeholder, disabled, validate, isInModal, isLoading, isMultiselect, options, iconComponentsMap,
}) => {
  return (
    <Field
      allowNull
      name={name}
      isEqual={customIsEqual}
      validate={validate}
    >
      {({ input, meta }) => {
        return (
          <StyledSelect
            small
            isLoading={isLoading}
            multiselect={isMultiselect}
            value={input.value}
            onChange={input.onChange}
            options={options}
            placeholder={placeholder}
            usePortal={isInModal ? true : undefined}
            portalZindex={isInModal ? PORTAL_Z_INDEX : undefined}
            disabled={disabled}
            iconComponentsMap={iconComponentsMap}
          />
        )
      }}
    </Field>
  )
}

SelectField.propTypes = {
  name: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  validate: PropTypes.func,
  isInModal: PropTypes.bool,
  isLoading: PropTypes.bool,
  isMultiselect: PropTypes.bool,
  options: PropTypes.oneOfType([
    PropTypes.array.isRequired,
    PropTypes.object.isRequired,
  ]),
  iconComponentsMap: PropTypes.object,
}

export default SelectField
